/**
 * Local record of Weekly Challenge attempts (D123): the first finished attempt
 * of a week is the scored one; later runs are practice. Kept per week id.
 */
const KEY = 'atf-weekly';

export interface WeeklyEntry {
  readonly score: number;
  readonly stars: number;
  readonly attempts: number;
}

function read(): Record<string, WeeklyEntry> {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Record<string, WeeklyEntry>;
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
}

export function weeklyEntry(week: string): WeeklyEntry | null {
  return read()[week] ?? null;
}

/** Record a finished run. `counted` = this run is the week's score. */
export function recordWeekly(week: string, r: { score: number; stars: number }): WeeklyEntry & { counted: boolean } {
  const all = read();
  const prev = all[week];
  const entry: WeeklyEntry = prev ? { ...prev, attempts: prev.attempts + 1 } : { score: r.score, stars: r.stars, attempts: 1 };
  all[week] = entry;
  // Keep the last 12 weeks only.
  const keys = Object.keys(all).sort();
  for (const k of keys.slice(0, Math.max(0, keys.length - 12))) delete all[k];
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* storage blocked */
  }
  return { ...entry, counted: !prev };
}
